export default __webpack_public_path__ + "static/15_aug_2021-ed71d9b2463002367be26821835f5666.png";